'use strict';

// Constructor
export class Footer {
    constructor() {
        $('#block-footermenu .menu-item--expanded').each(function(i,menuitem){
            var $menuitem = $(menuitem);
            var expander = "<a href='#expander' class='expander'></a>";
            $menuitem.append(expander);
        })

        $('#block-footermenu').on('click', '.expander', function(e){
            e.preventDefault();
            $(this).parents('.menu-item--expanded').toggleClass('expanded');
            console.log($(this).siblings('ul'));
            $(this).siblings('ul').slideToggle();
        })
    }
}